"use client";

import { lazy, Suspense, useState } from "react";
import { DialogDismissalLayer } from "@/components/ui/dialog-dismissal-layer";
import type { useViewActions } from "./use-view-actions";
import type { RecordTableState, RecordViewDraft } from "../types";

const SaveViewDialog = lazy(() => import("./save-view-dialog").then((module) => ({ default: module.SaveViewDialog })));

export function SaveCurrentViewDialog({
  open,
  onOpenChange,
  draft,
  state,
  actions,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  draft: RecordViewDraft | null;
  state: RecordTableState;
  actions: ReturnType<typeof useViewActions>;
}) {
  const [hasOpened, setHasOpened] = useState(open);
  if (open && !hasOpened) setHasOpened(true);
  const stored: RecordViewDraft = draft ?? {
    filters: state.filter.conditions,
    sort: state.sort,
    columnOrder: state.columns.order,
    columnHidden: state.columns.hidden,
  };

  return hasOpened ? (
    <Suspense fallback={<DialogDismissalLayer open={open} onOpenChange={onOpenChange} />}>
      <SaveViewDialog
        open={open}
        onOpenChange={onOpenChange}
        onSave={async (name, scope) => {
          await actions.createView({ name, scope, ...stored });
        }}
      />
    </Suspense>
  ) : null;
}
